// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";
import {SimScenarioService} from "@services";
import {from, Observable, of} from "rxjs";
import {map} from "rxjs/operators";

@Pipe({
	name: "getScenarioGroupNameByScenarioId",
	standalone: false,
})
export class GetScenarioGroupNameByScenarioIdPipe implements PipeTransform {
	constructor(private _simScenarioService: SimScenarioService) {}

	transform(scenarioGroupId: string): Observable<string> {
		if (!scenarioGroupId) {
			return of("");
		}

		return from(this._simScenarioService.getScenarioGroups()).pipe(
			map((scenarioGroup) => {
				let scenarioGroupName: string = scenarioGroup?.find((scenarioGroup) => scenarioGroup?.id === scenarioGroupId)?.name;
				return scenarioGroupName ?? "";
			}),
		);
	}
}
